<template>
  <div class="barcode-container">
    <canvas ref="barcodeCanvas" />
    <div class="fiscalCode-text">*{{ fiscalCode }}*</div>
  </div>
</template>

<script>
import JsBarcode from "jsbarcode";

export default {
  name: "BarcodeFiscalCode",
  props: {
    fiscalCode: { type: String, required: true }
  },
  mounted() {
    this.generateBarcode();
  },
  watch: {
    fiscalCode() {
      this.generateBarcode();
    }
  },
  methods: {
    generateBarcode() {
      if (!this.fiscalCode) return;
      const canvas = this.$refs.barcodeCanvas;

      JsBarcode(canvas, this.fiscalCode, {
        format: "CODE39",
        lineColor: "#000",
        background: "#fff",
        width: 0.9,       // ⬅️ ridotto da 2.2 a 1.1 per accorciare
        height: 28.35,     // 8mm esatti
        margin: 5,         // margini minimi ma sufficienti
        displayValue: false
      });
    }
  }
};
</script>

<style scoped>
.barcode-container {
  text-align: center;
  margin: 0 auto;
}
canvas {
  display: block;
}
.fiscalCode-text {
  font-family: "Courier New", monospace;
  font-size: 14px;
  margin-top: 4px;
}
</style>
